import { DatePipe } from '@angular/common'
import { Component, Input, inject } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CustomPopoverOptions } from '@interfaces'
import {
	IonAlert,
	IonAvatar,
	IonBadge,
	IonHeader,
	IonIcon,
	IonInfiniteScroll,
	IonInfiniteScrollContent,
	IonItem,
	IonLabel,
	IonList,
	IonLoading,
	IonSkeletonText,
	IonTitle,
	IonToolbar,
	PopoverController
} from '@ionic/angular/standalone'
import { TranslateModule } from '@ngx-translate/core'

@Component({
	selector: 'app-popover',
	standalone: true,
	templateUrl: './list-popover.component.html',
	styleUrls: ['./list-popover.component.scss'],
	imports: [
		IonIcon,
		IonHeader,
		IonToolbar,
		IonTitle,
		IonLabel,
		IonBadge,
		IonAvatar,
		IonItem,
		IonList,
		IonLoading,
		IonInfiniteScroll,
		IonInfiniteScrollContent,
		IonSkeletonText,
		IonAlert,
		DatePipe,
		RouterModule,
		TranslateModule
	]
})
export class ListPopoverComponent {
	private popoverController = inject(PopoverController)

	@Input() options: CustomPopoverOptions[] = []
	@Input() listed: boolean = true

	executeAction(action: () => void) {
		action()
		this.popoverController.dismiss()
	}
}
